// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container/styles/Container';
export var DirectionalContainer = function (_a) {
    var directionalContainerStyles = _a.directionalContainerStyles, children = _a.children;
    return directionalContainerStyles ? (React.createElement(Container, { display: 'inline-flex', position: 'absolute', width: '100%', height: '100%', pointerEvents: 'none', alignItems: directionalContainerStyles.alignItems, justifyContent: directionalContainerStyles.justifyContent }, children)) : (React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=DirectionalContainer.js.map